import { Component, Input, OnInit } from "@angular/core";
import {
  Form_Fields,
  E_Form_Type,
  IForm_Fields,
} from "../../models/wire-count-labels";
@Component({
    selector: "app-wire-count-data",
    templateUrl: "./wire-count-data.component.html",
    styleUrls: ["./wire-count-data.component.scss"],
    standalone: false
})
export class WireCountDataComponent implements OnInit {
  @Input() dwcdata;
  formTypeName;
  fieldsAre: IForm_Fields[];

  constructor() {}

  ngOnInit() {
    this.formTypeName = E_Form_Type[this.dwcdata.formType];
    this.fieldsAre = Form_Fields[this.dwcdata.formType];
  }

  getValue(q) {
    return this.dwcdata[q] ? this.dwcdata[q] : "-";
  }
}
